module.exports = __webpack_public_path__ + "img/check-img.f044a608.png";